import React from 'react';

import ItemsProviderWithStore, {
	ItemsProviderWithStoreContextActions,
} from '@common/react/components/Core/ItemsProviderWithStore/ItemsProviderWithStore';
import {
	BaseFilters,
	ItemsProviderContext,
	List,
} from '@common/react/components/Core/ItemsProvider/ItemsProvider';

import {
	AppointmentType,
	SystemAppointmentType,
} from '@app/objects/Appointment';
import { defaultOptions } from '@app/components/UI/AppointmentType/defaultOptions';

interface AppointmentTypesProviderActions extends ItemsProviderWithStoreContextActions<AppointmentType,
	BaseFilters, List<AppointmentType>> {
	getAppointmentTypeWithSAType: (saStatus: SystemAppointmentType) => AppointmentType | null;
}

interface AppointmentTypesProviderContext extends ItemsProviderContext<AppointmentType,
	BaseFilters, List<AppointmentType>, AppointmentTypesProviderActions> {}

interface AppointmentTypesProviderProps {
	children?: React.ReactNode | ((context: AppointmentTypesProviderContext) => React.ReactNode);
}

export const AppointmentTypesProvider: React.FC<AppointmentTypesProviderProps> = ({ children }) => {
	return <ItemsProviderWithStore<AppointmentType, BaseFilters>
		{...defaultOptions}
	>
		{(context) =>
			(typeof children === 'function'
				? children({
					...context,
					actions: {
						...context.actions,
						getAppointmentTypeWithSAType: (saType) => (context.state.items.find((q) => q.saType === saType)),
					},
				} as AppointmentTypesProviderContext)
				: children)
		}
	</ItemsProviderWithStore>;
};
